import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { ImageView } from '@play-co/timestep-core/ui';
import { PetEntity } from 'src/game/logic/EntityManager';
import { getPet } from 'src/game/pet';
import { petAnimationNames } from 'src/replicant/pet/PetAssets';
import * as Pet from 'src/replicant/pet';
import { user } from 'src/StateObserver';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (invite?: boolean) => void;

export default class PopupNoFriends extends PopupBasic {
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 600,
      darkerBg: false,
      superview: opts.superview,
      close: () => opts.close(),
      tracking: {
        feature: Feature.VISIT._,
        $subFeature: Feature.VISIT.NO_FRIENDS,
      },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      y: 360,
      height: 100,
      wordWrap: true,
    });

    new ImageView({
      superview: this.box,
      image: 'assets/ui/visit/invite/invite_shadow.png',
      width: 441,
      height: 155,
      x: this.box.style.width / 2,
      y: 180,
      centerOnOrigin: true,
    });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.cancel,
        labelOffsetY: -1,
        fontSize: 46,
        font: 'Body',
        width: 230,
        height: 100,
        x: this.box.style.width / 4,
        y: this.box.style.height - 70,
        centerOnOrigin: true,
        localeText: () => i18n('basic.cancel'),
        onClick: async () => {
          sounds.sfx.play('cancel');
          return opts.close();
        },
        tracking: {
          feature: Feature.VISIT._,
          $subFeature: Feature.VISIT.NO_FRIENDS_CLOSE,
        },
      }),
    );
    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        labelOffsetY: -1,
        fontSize: 46,
        font: 'Body',
        width: 230,
        height: 100,
        x: (3 * this.box.style.width) / 4,
        y: this.box.style.height - 70,
        centerOnOrigin: true,
        localeText: () => i18n('social.invite.referral.cta'),
        onClick: async () => {
          sounds.sfx.play('ok');
          return opts.close(true);
        },
        tracking: {
          feature: Feature.VISIT._,
          $subFeature: Feature.VISIT.NO_FRIENDS_INVITE,
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/visit/invite/invite_shadow.png']);
  }

  public init() {
    super.init({
      title: i18n('friendsVisit.invite.title'),
      message: i18n('friendsVisit.invite.message'),
    });

    const species = Pet.getters.getCurrentEvolution(user())?.species ?? 'dog';

    const pet = new PetEntity('revivalPet', species);
    pet.updateOpts({
      superview: this.box,
      x: this.box.style.width / 2,
      y: 360,
      scale: 0.7,
      anchorX: 0.5 * pet.style.width,
      anchorY: 0.5 * pet.style.height,
    });

    const petAnimations = petAnimationNames[species];
    pet.setAnimation(petAnimations.normal.idle);
  }
}
